import {useMutation, type UseMutationOptions} from '@tanstack/react-query';
import {appRouter} from '@netx/core-next/instance';
import {
	removeAttributeVocabulary,
	// removeAttributeVocabularyEndpoint,
	type QueryError,
	type RemoveAttributeVocabularyResult,
	type RemoveAttributeVocabularyRequestOptions,
} from '../removeAttributeVocabulary';
import {splitEventHandler} from '@netx/core-next/utils';
export * from '../removeAttributeVocabulary';

export type RemoveAttributeVocabularyQueryOptions = Omit<
	UseMutationOptions<
		RemoveAttributeVocabularyResult,
		QueryError,
		RemoveAttributeVocabularyRequestOptions,
		RemoveAttributeVocabularyResult
	>,
	'mutationFn'
> & {
	mutationFn?: typeof removeAttributeVocabulary;
};

/**
 * react-query wrapper for `removeAttributeVocabulary`
 * @param queryKeyParams
 * @param options
 */
export const useReactQueryRemoveAttributeVocabulary = ({
	mutationFn = removeAttributeVocabulary,
	...options
}: RemoveAttributeVocabularyQueryOptions = {}) =>
	useMutation<
		RemoveAttributeVocabularyResult,
		QueryError,
		RemoveAttributeVocabularyRequestOptions,
		RemoveAttributeVocabularyResult
	>({
		mutationFn,
		...options,
		onSuccess: splitEventHandler(options.onSuccess, (id) => {
			if (
				window.location.hash.match(
					/^#system\/attribute\/vocabularies\/(\d+)$/,
				)?.[1] === id.toString()
			) {
				appRouter.navigate('system/attribute/vocabularies', true);
			}
		}),
	});

export default useReactQueryRemoveAttributeVocabulary;
